<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="26"
		height="24"
		viewBox="0 0 26 24"
		fill="none"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M4.21356 8.18719C4.60769 7.82107 5.2467 7.82107 5.64083 8.18719L13.001 15.0243L20.3612 8.18719C20.7553 7.82107 21.3944 7.82107 21.7885 8.18719C22.1826 8.5533 22.1826 9.14689 21.7885 9.51301L13.7147 17.013C13.3205 17.3791 12.6815 17.3791 12.2874 17.013L4.21356 9.51301C3.81944 9.14689 3.81944 8.5533 4.21356 8.18719Z"
			fill="#000"
		/>
	</svg>
</template>
